import { Download } from "@mui/icons-material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import NoteBackgroundImg from "../../../../assets/images/note-background.png";
import CommonButton from "../../../../component/Button";
import { HandleSkeletion } from "../../../../utils/constants";
import {
  StyledTableBodyTableCell,
  StyledTableTitleTableCell,
  TableContainerBorder,
} from "../../../common-components/StyledComponents";

function DownloadJD({
  openDownloadJdDialog,
  handleCloseDownloadJdDialog,
  jdFileList,
  handleDownloadJd,
  jdFileListLoader,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth={"md"}
      open={openDownloadJdDialog}
      onClose={handleCloseDownloadJdDialog}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "700px",
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      <img
        src={NoteBackgroundImg}
        style={{ position: "absolute", width: "max-content", opacity: "0.7" }}
      />
      <DialogActions>
        <CommonButton
          onClick={handleCloseDownloadJdDialog}
          padding={"10px"}
          background={"rgba(127, 86, 217, 0.04)"}
          border="rgba(127, 86, 217, 0.5)"
          height={"100%"}
          value={<XCloseIco />}
          boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
        />
      </DialogActions>
      <DialogTitle>
        <Typography variant="h3" sx={{ mt: 2 }}>
          {"Download Job"}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <TableContainerBorder sx={{ marginTop: "0px !important" }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableTitleTableCell>
                  {"File Name"}
                </StyledTableTitleTableCell>
                <StyledTableTitleTableCell align="right">
                  {"Download"}
                </StyledTableTitleTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {jdFileListLoader
                ? Array.from(new Array(3)).map((el, ind) => (
                    <TableCell sx={{ width: "100%" }}>
                      <HandleSkeletion
                        key={`key-${ind.toString()}`}
                        width={"100%"}
                        height={100}
                      />
                    </TableCell>
                  ))
                : jdFileList.map((row) => (
                    <TableRow key={row.id}>
                      <StyledTableBodyTableCell>
                        {row.file_name}
                      </StyledTableBodyTableCell>

                      <TableCell align="right">
                        <IconButton onClick={() => handleDownloadJd(row)}>
                          <Download />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainerBorder>
      </DialogContent>
    </Dialog>
  );
}

export default DownloadJD;
